import React from 'react';

// ── Shared Types ──

export interface ZipcodeRecord {
  Name: string;
  'Pricing Zone': string;
  'Zip Code': number;
  County: string;
  City: string;
  State: string;
  'City Alias Name': string;
  'Offer to Affiliates?': string;
}

export interface LookupResult {
  city: string;
  zipCode: number;
  county: string;
  zone: string;
  areaName: string;
  aliases: string[];
  courtZone: string | null;
}

export interface LocationLabCourtRecord {
  County: string;
  Jurisdiction: string;
  Address: string;
  City: string;
  State: string;
  'Pricing Zone': string;
  'Offer to Affiliates?': string;
}

// ── Zone Color Helpers ──

const ZONE_COLORS: Record<string, { bg: string; text: string; fill: string }> = {
  'Remote Area': { bg: '#F3F4F6', text: '#374151', fill: '#9CA3AF' },
  'Suburban Area': { bg: '#DBEAFE', text: '#1E40AF', fill: '#60A5FA' },
  'Urban Area': { bg: '#D1FAE5', text: '#065F46', fill: '#34D399' },
  'Remote Court': { bg: '#F3F4F6', text: '#374151', fill: '#9CA3AF' },
  'Suburban Court': { bg: '#DBEAFE', text: '#1E40AF', fill: '#60A5FA' },
  'Urban Court': { bg: '#D1FAE5', text: '#065F46', fill: '#34D399' },
  'eFiling: California': { bg: '#FEF3C7', text: '#92400E', fill: '#FBBF24' },
};

export const getZoneStyle = (zone: string) => ZONE_COLORS[zone] ?? { bg: '#F3F4F6', text: '#374151', fill: '#9CA3AF' };

export const ZoneBadge: React.FC<{ zone: string }> = ({ zone }) => {
  const style = getZoneStyle(zone);
  const label = zone.replace(' Area', '').replace(' Court', '');
  return React.createElement('span', {
    className: 'inline-block px-2 py-0.5 rounded text-xs font-medium',
    style: { backgroundColor: style.bg, color: style.text },
  }, label);
};
